import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApprovalRefreshService {
  private _refreshTrigger = signal(0);
  private _pathStartStatusList = signal<string[]>([]);

  readonly refreshTrigger = this._refreshTrigger.asReadonly();
  readonly pathStartStatusList = this._pathStartStatusList.asReadonly();

  /**
   * Trigger a refresh event for approval-related components
   * This will notify all components listening to refreshTrigger to reload their data
   */
  triggerRefresh(): void {
    this._refreshTrigger.update((trigger) => trigger + 1);
  }

  /**
   * Update the pathStartStatusList to share with other components
   */
  updatePathStartStatusList(statusList: string[]): void {
    this._pathStartStatusList.set(statusList);
  }
}

